<template>
  <el-dialog :visible.sync="isModalVisible" :show-close="false" :close-on-click-modal="false">
    <span slot="title" class="font-weight-bold h4">
    </span>
    <el-row type="flex" justify="center">
      <el-col :span="24" v-if="isError" class="text-center">
        <i class="fas fa-exclamation-circle fa-5x text-danger"></i>
      </el-col>
      <el-col :span="24" v-else justify="center" class="text-center">
        <i class="fas fa-info-circle text-secondary fa-5x"></i>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="24" class="text-center">
        <h3 v-html="notificationText"></h3>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer-center">
      <el-row :gutter="20" justify="center">
        <el-button size="small" type="info" @click="cancel"
          > {{ isError ? 'Close' : 'Back' }}</el-button
        >
        <el-button v-if="isConfirmation" size="small" :type="isConfirmation ? 'success' : 'danger'" @click="confirm" :loading="notificationBtnLoading"
          >{{ confirmButtonText }}</el-button
        >
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import breakpoint from "@/mixins/index";

export default {
  components: {},
  mixins: [breakpoint],
  props: {
    notificationText: {
      type: String,
      required: false,
      default: ""
    },
    isModalVisible: {
      type: Boolean,
      required: true,
    },
    isError: {
      type: Boolean,
      required: false,
      default: false,
    },
    isConfirmation: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmButtonText: {
      type: String,
      required: false,
      default: "",
    },
    notificationBtnLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    confirm() {
      this.$emit("confirmedNotification");
    },
    cancel() {
      this.$emit("closeNotification");
    }
  },
};
</script>
<style>
</style>